import { requireAuth } from '@/features/auth/guards/require-auth'
import { PositionsPage } from '@/features/references/positions/positions-page'
import { positionsListQuery } from '@/features/references/positions/positions-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/references/positions')({
  beforeLoad: requireAuth,
  loader: ({ context }) => context.queryClient.ensureQueryData(positionsListQuery()),
  component: PositionsPage,
  staticData: { crumb: messages.crumbs.refPositions },
})
